export default __webpack_public_path__ + "static/char-v-01-e202f8eb6d6c290b24fd6e5097e756d2.mp4";